export const sr = {
  whatsNew: {
    title: "Šta je novo",
    intro: "Evo šta je novo u Vamos Tamos.",
    teamsTitle: "Sačuvajte svoje timove",
    teamsBody: "Sačuvajte spisak igrača sa imenom i PIN-om od 4 cifre i učitajte ga bilo kada.",
    languagesTitle: "Više jezika",
    languagesBody: "Vamos Tamos sada govori 6 jezika, uključujući nemački i indonežanski.",
    cta: "U redu",
    badge: "Novo",
  },
  common: {
    loading: "Učitavanje...",
    points: "poena",
    court: "Teren",
    team: "Tim",
    player: "Igrač",
    rank: "Rang",
    score: "Rezultat",
    share: "Podeli rezultate",
    linkCopied: "Link kopiran u clipboard",
    shareFailed: "Turnir je prevelik za deljenje putem URL-a. Pokušaj sa manje igrača.",
    and: "i",
    close: "Zatvori",
    save: "Sačuvaj",
    cancel: "Otkaži",
    back: "Nazad",
    yes: "Da, Ukloni",
    no: "Ne, Nazad",
    editable: "Izmenljivo",
    buyMeCoffee: "Kupi mi kafu",
  },
  results: {
    leastGames: "Najmanje mečeva",
    leastGamesTooltip: "Najmanje odigranih mečeva",
  },
  tournament: {
    new: "Americano ili Mexicano?",
    create: "Kreiraj Turnir",
    nameRequired: "Ime turnira je obavezno",
    tournamentName: "Ime turnira",
    round: "Runda",
    completeRound: "Završi Rundu",
    completingRound: "Završavanje...",
    nextRoundReady: "Runda #{round} je spremna",
    endTournament: "Završi Turnir",
    formatRequired: "Izaberi Americano ili Mexicano",
    enterScores: "Unesite sve rezultate pre završetka runde",
    bench: "Igrači na klupi",
    finalResults: "turnir",
    finished: "Turnir Završen",
    winner: "Pobednik",
    winners: "Pobednici",
    with: "sa",
    points: "poena",
    summary: "Turnir je završen u {rounds} rundi sa {players} igrača na {courts} terena.",
    confirmEnd: "Da li ste sigurni? Poeni iz ove runde neće biti uključeni u ukupan rezultat",
    yes: "Da",
    no: "Ne",
    newTournament: 'Započni Novi Turnir',
    playedMatches: 'Odigrano',
    pairingComplete: "Uparivanje Završeno",
    roundSaved: "Runda #{round} sačuvana",
    allPlayersPaired: "Turnir je završen!",
    continueWithNewPairs: "Nastavi sa Turnirom",
    viewResults: "Prikazi Rezultate",
    tournamentEnded: "Turnir Završen",
    roundSettings: "Podešavanja runde",
    pointsModeLabel: "Poeni do {points}",
    timeModeLabel: "Vreme, {minutes} min",
    timer: "Tajmer: {time}",
    timerStatus: "Tajmer runde",
    timeUp: "Vreme je isteklo! Završite rundu i unesite rezultate.",
    editRoster: "Izmeni Igrače",
    editRosterTitle: "Izmeni Igrače i Terene",
    addPlayer: "Dodaj Igrača",
    removePlayer: "Ukloni",
    reactivatePlayer: "Reaktiviraj",
    inactivePlayers: "Neaktivni Igrači",
    applyChanges: "Primeni Izmene",
    rosterWarning: "Trenutna runda će biti regenerisana i rezultati resetovani",
    rosterWarningTitle: "Primena izmena će ponovo pokrenuti ovu rundu",
    rosterWarningRegenerate: "Timovi za trenutnu rundu biće promešani i ponovo generisani.",
    rosterWarningScores: "Svi rezultati već uneti za ovu rundu biće obrisani.",
    rosterWarningNewPlayers: "Novi igrači se odmah uključuju i dodaju u ovu rundu.",
    rosterWarningSafe: "Rezultati iz prethodnih, završenih rundi se čuvaju.",
    minPlayersWarning: "Potrebno je najmanje 4 aktivna igrača",
    courtsReduced: "Tereni smanjeni na {courts} (nedovoljno aktivnih igrača)",
    playerInactive: "Neaktivan",
    mixedPairsWarning: "Mešoviti parovi zahtevaju jednak broj muškaraca i žena",
    arrangeFirstRound: "Podesi prvu rundu",
    arrangeFirstRoundTitle: "Podesi prvu rundu",
    arrangeFirstRoundHelp: "Dodirni ili klikni jednu karticu igrača, pa zatim drugo mesto da ih zameniš. Koristi klupu da zameniš igrače koji ulaze ili izlaze. Radi isto na mobilnom i desktopu.",
    resetFirstRound: "Poništi izmene",
    firstRoundUpdated: "Prva runda je ažurirana",
    manualFirstRoundInvalid: "Svaki aktivni igrač mora da se pojavi tačno jednom u podešavanju prve runde.",
    manualFirstRoundMixedPairs: "Mešoviti parovi traže jednog muškarca i jednu ženu u svakom timu.",
    manualFirstRoundBenchSlot: "Klupa {number}",
    removePlayerTitle: "Ukloni Igrača",
    removePlayerMessage: "Kako želite da uklonite {player}?",
    removePlayerExplanation: "Deaktiviraj: Igrač ostaje na tabeli ali neće biti dodeljen mečevima. Ukloni Potpuno: Igrač se briše iz turnira u potpunosti.",
    makeInactive: "Deaktiviraj (zadrži na tabeli)",
    removeCompletely: "Ukloni Potpuno (obriši iz turnira)",
    removePlayerFinalTitle: "Da li ste sigurni?",
    removePlayerFinalMessage: "Ovo će trajno obrisati {player} i sve njihove poene iz turnira. Ova akcija se ne može poništiti."
  },
  tvMode: {
    subtitle: "Prikažite ovu stranicu na TV-u za tabelu i terene uživo",
    round: "Runda {round}",
    leaderboard: "Rang lista",
    lastRound: "Poslednja runda",
    onCourt: "Na terenu",
    noGames: "Nema aktivnih mečeva",
    bench: "Čekaju ovu rundu",
    missingStateTitle: "TV režimu je potreban link turnira",
    missingStateBody: "Otvorite TV režim iz aktivnog ili završenog turnira da biste prikazali podatke na ekranu.",
    openButton: "Otvori TV režim",
  },
  theme: {
    switchToDark: 'Prebaci na tamni režim',
    switchToLight: 'Prebaci na svetli režim',
    toggleLabel: 'Promeni režim boja',
  },
  playerSetup: {
    title: "Ko igra?",
    addPlayer: "Dodaj Igrača",
    playerName: "Igrač",
    playerRequired: "Ime igrača je obavezno",
    formatTitle: "Stil turnira",
    formatAmericano: "Americano igra",
    formatMexicano: "Mexicano igra",
    courtsTitle: "Broj terena",
    court: "Teren",
    courts: "Terena",
    startTournament: "Počni Turnir",
    loadTeam: "Učitaj tim",
    saveTeam: "Sačuvaj tim",
    loadTeamTitle: "Učitaj sačuvani tim",
    saveTeamTitle: "Sačuvaj ovaj tim",
    teamCode: "Ime tima",
    loadTeamHint: "Unesite lako pamtljivo ime tima da biste ponovo koristili njegovu listu igrača.",
    saveTeamHint: "Dajte ovoj listi igrača lako pamtljivo ime da biste je ponovo koristili sledeći put.",
    savedTeamsTitle: "Vaši sačuvani timovi",
    noSavedTeams: "Još uvek nema sačuvanih timova na ovom uređaju.",
    teamNameRequired: "Unesite ime tima",
    noPlayersToSave: "Dodajte bar jednog igrača pre čuvanja",
    teamNotFound: "Nije pronađen sačuvani tim sa tim imenom",
    teamSaved: "Tim sačuvan",
    teamSaveFailed: "Tim nije moguće sačuvati. Pokušajte ponovo.",
    teamSavedLocally: "Tim je sačuvan na ovom uređaju. Deljenje još nije potvrđeno.",
    teamLoaded: "Tim učitan",
    updatingTeam: "Čuvanje će ažurirati vaš tim \"{name}\".",
    teamNameTaken: "To ime je već zauzeto. Dodirnite predlog ili unesite drugo.",
    suggestionLabel: "Predloženo ime",
    load: "Učitaj",
    createTeam: "Napravi tim",
    pinFourDigits: "PIN (4 cifre)",
    pinEnterPrompt: "Unesite PIN tima od 4 cifre.",
    pinCreateWarning: "Ovaj PIN će vam trebati da kasnije učitate tim. Ne može se povratiti \u2014 ako ga zaboravite, moraćete da napravite novi tim.",
    pinInvalid: "PIN mora imati 4 cifre.",
    pinIncorrect: "Pogrešan PIN. PIN se ne može povratiti \u2014 napravite novi tim ako ste ga zaboravili.",
    notEnoughPlayers: "Potrebno je najmanje {count} igrača za {courts} terena",
    duplicateName: "Ime vec postoji",
    roundTypeTitle: "Tip runde",
    roundTypePoints: "Poeni",
    roundTypeTime: "Vremenski",
    targetPoints: "Broj poena",
    roundMinutes: "Minuta po rundi",
    timerHint: "Svirnuće pištaljka i pojaviće se baner kada vreme istekne.",
    mixedPairsLabel: "Mešoviti parovi (M+Ž)",
    mexicanoPairingTitle: "Mexicano uparivanje",
    mexicanoPairingHint: "Izaberi kako se grupa od 4 igrača deli u timove na svakom terenu.",
    mexicanoPairingStandard: "Opcija 1: #1 + #3 protiv #2 + #4",
    mexicanoPairingStandardDescription: "Spaja prvoplasiranog sa trećeplasiranim, a drugoplasiranog sa četvrtoplasiranim na svakom terenu.",
    mexicanoPairingAlternate: "Opcija 2: #1 + #4 protiv #2 + #3",
    mexicanoPairingAlternateDescription: "Spaja najboljeg igrača sa četvrtim, a srednja dva zajedno na svakom terenu.",
    gender: "Pol",
    male: "Muško",
    female: "Žensko",
    genderBalance: "Mešoviti parovi traže jednak broj muških i ženskih igrača."
  },
  rules: {
    titleAmericano: 'Kako Americano funkcioniše',
    titleMexicano: 'Kako Mexicano funkcioniše',
    teamSetupTitle: 'Formiranje timova',
    teamSetupAmericano: 'Igrači se nasumično raspoređuju u timove pre svake runde kako bi se osigurale različite kombinacije timova i protivnika.',
    teamPattern13v24: '#1+#3 igraju protiv #2+#4',
    teamPattern14v23: '#1+#4 igraju protiv #2+#3',
    teamSetupMexicano: 'Uparivanje zavisi od trenutne rang liste. Igrači se grupišu po 4 prema rangu (top 4, sledeća 4, itd). Na svakom terenu: {pattern}. Sledeći teren prati isti obrazac. Ovo znači da jači igraju protiv jačih, a slabiji protiv slabijih — cilj je visok individualni rezultat, a ne jedan pobednički par.',
    scoringSystemTitle: 'Sistem bodovanja',
    scoringSystem: 'Svaka runda se igra do određenog broja poena ili na vreme. Poeni se dodeljuju individualno – na primer, ako tim pobedi 13–8, svaki igrač pobedničkog tima dobija 13 poena, a gubitnici dobijaju 8.',
    winnerTitle: 'Pobednik',
    winner: 'Igrač sa najviše poena ukupno pobeđuje i dobija aplauz od ostalih. :)',
    faqTitle: 'Često postavljana pitanja',
    faqFormatsQ: 'Koja je razlika između Americana i Mexicana?',
    faqFormatsA: 'U Americanu se igrači nasumično pariraju svake runde, pa svako igra sa svima i protiv svih. U Mexicanu parovi prate trenutnu tabelu i spajaju igrače sličnog ranga.',
    faqSportsQ: 'Mogu li da ga koristim za sportove osim padela?',
    faqSportsA: 'Da. Iako je napravljen za padel, formati Americano i Mexicano rade za piklbol, tenis, stoni tenis, badminton i svaku igru koja se boduje poenima.',
    faqFreeQ: 'Da li je besplatan i da li mi treba nalog?',
    faqFreeA: 'Potpuno je besplatan, bez registracije. Turniri rade u vašem pretraživaču i funkcionišu oflajn.',
    faqPlayersQ: 'Koliko igrača i terena mogu da koristim?',
    faqPlayersA: 'Bilo koji broj igrača na jednom ili više terena. Aplikacija automatski rotira igrače svake runde.'
  },
  privacy: {
    title: 'Politika Privatnosti',
    lastUpdated: 'Poslednje ažurirano',
    dataCollection: 'Prikupljanje Podataka',
    dataCollectionText: 'Vamos Tamos ne prikuplja niti čuva lične podatke. Svi podaci o turniru ostaju na vašem uređaju.',
    localStorage: 'Lokalno Skladište',
    localStorageText: 'Podaci o turniru se čuvaju lokalno u localStorage pretraživača da bi se održao status igre. Možete obrisati ove podatke u bilo kom trenutku kroz postavke pretraživača.',
    cookies: 'Kolačići',
    cookiesText: 'Ova aplikacija ne koristi kolačiće za praćenje. Samo osnovno skladište pretraživača (localStorage) se koristi za funkcionalnost turnira.',
    thirdParty: 'Usluge Trećih Strana',
    thirdPartyText: 'Koristimo Vercel Web Analytics za prikupljanje anonimnih, agregiranih podataka o korišćenju (pregledi stranica, broj posetilaca). Ovi podaci su fokusirani na privatnost i ne prate pojedinačne korisnike, ne koriste kolačiće, niti prikupljaju lične informacije. Više na vercel.com/analytics.',
    rights: 'Vaša Prava (GDPR/CCPA)',
    rightsText: 'Pošto se lični podaci ne prikupljaju niti obrađuju, zadržavate punu kontrolu nad svojim podacima. Možete obrisati sve lokalno sačuvane podatke o turniru čišćenjem localStorage pretraživača.',
    contact: 'Kontakt',
    contactText: 'Za pitanja o privatnosti, kontaktirajte: the.adnan@gmail.com',
    backHome: 'Nazad na Početnu'
  }
};
